import accountMgmtSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const accountMgmtActions = { ...actions, ...thunkActions };
export * as AccountMgmtTypes from './types';
export default accountMgmtSlice;
